import React from 'react';
import './App.css';
import DocPage from './docs/DocPage';
import Util from './Util';

export default class App extends React.Component {

  private getLanguage(): string {
    var result = Util.getParamFromUrl('l') || '';
    if (Util.isNotEmpty(result)) return result.trim();
    result = navigator.language;
    if (Util.isNotEmpty(result) && result.length >= 2) {
      result = result.substring(0, 2);
      return result;
    }
    return '';
  }

  render(): React.ReactNode {

    var doc = Util.getParamFromUrl('d');
    let lang = this.getLanguage();

    if (!doc) return <></>;

    return (
      <div className="App">
        <DocPage doc={doc} lang={lang} />
      </div>);
  }

}


